module.exports = __webpack_public_path__ + "src/assets/img/visual_70years_goodbye.9a126671.png";